import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FeatureInfo } from 'app/website/models/feature.model';
import { FeatureSummary } from 'app/website/models/feature-summary.model';
import { CarouselCaption, MediaTypes } from 'app/website/models/carousel-caption.model';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent implements OnInit {
  constructor(private ecoDocsTitleService: EcoDocsTitleService) { }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle('Workflow Automation, Business Intelligence & ECM  Software', false);
  }

  carouselCaptions: CarouselCaption[] = [
    {
      title: 'Go Digital',
      description: 'Convert paper documents to user-friendly digital documents, build E-forms and set permissions and assign roles all in one place. Capture your documents digitally. Manage, organize and apply OCR and text extraction and much more features.',
      mediaUrl: '/assets/img/go_digital.jpg',
      mediaType: MediaTypes.IMAGE,
      url:'/site/go-paperless',
      urlTitle: 'More...'
    },
    {
      title: 'Document Management & Collaboration',
      description: 'Collaboration between your different departments has never been easier. Now you can capture, secure, and organize files and data, then easily share it with other team members and departments. You can save countless hours streamlining this process.',
      mediaUrl: '/assets/img/document_collaboration.jpg',
      mediaType: MediaTypes.IMAGE,
      url:'/site/automate-workflows',
      urlTitle: 'More...'
    },
    {
      title: 'Automate Your Workflows',
      description: 'EcoDocs is a workflow management software that helps you create customized pre-configured approval and review workflows, access live data, schedule reports and more.',
      mediaUrl: '/assets/img/carousel_workflow_automation.jpg',
      mediaType: MediaTypes.IMAGE,
      url:'/site/automate-workflows',
      urlTitle: 'More...'
    },
    {
      title: 'Real-time Reports & Insights',
      description: 'EcoDocs helps you discover, analyze, measure, improve, optimize, and automate your business processes through graphical dashboards and reports that are customized for every use case .',
      mediaUrl: '/assets/img/carousel_reports_analytics.jpg',
      mediaType: MediaTypes.IMAGE,
      url:'/site/data-reports-and-analytics',
      urlTitle: 'More...'
    }
  ]
  
  feature1: FeatureInfo =  {
      imgUrl: '/assets/img/paper_problems.jpg',
    }
    feature2: FeatureInfo ={
      imgUrl: '/assets/img/document_management.jpg',
    }
    feature3: FeatureInfo = {
      imgUrl: '/assets/img/workflow_automation_feature.jpg',
    }
    feature4: FeatureInfo = {
      imgUrl: '/assets/img/reports_analytics_feature.jpg',
    }
  
    moreFeatures: FeatureSummary[] = [
      {
        title: 'Highly Secure',
        desciption: 'Configure your users and teams and define who has permission to what.',
        icon: 'fas fa-3x fa-user-shield'
      },
      {
        title: 'Easy Search',
        desciption: 'Sort, categorize, apply OCR and text extraction for full-text searching and indexing on all your documents. ',
        icon: 'fas fa-3x fa-search'
      },
      {
        title: 'Compatibility',
        desciption: 'The system can be easily integrated with any on-premises storage through FTP, SFTP, and WebDAV.',
        icon: 'fas fa-3x fa-check-double'
      },
      {
        title: 'Forms Builder',
        desciption: 'Easily build complicated forms used in any industry with the drag-and-drop forms builder. No coding required!',
        icon: 'fab fa-3x fa-wpforms'
      },
      {
        title: 'Auto Validation',
        desciption: 'Your data is automatically validated when entered using Custom logic, Relation-based, Value-based or conditional validation.',
        icon: 'far fa-3x fa-check-circle'
      },
      {
        title: 'Custom Workflows',
        desciption: 'Use the visual tree view workflow template builder to create highly-sophisticated workflows with multi-step approval and review processes.',
        icon: 'fas fa-3x fa-sitemap'
      },
      {
        title: 'Custom Dashboards',
        desciption: 'Build customized dashboards for different users to help make the right decisions.',
        icon: 'fas fa-3x fa-tachometer-alt'
      },
      {
        title: 'Real-time Analytics',
        desciption: 'As soon as forms are filled and submitted, the filled data is available for advanced analysis and visualization..',
        icon: 'far fa-3x fa-chart-bar'
      }
    ]
}
